<template>
  <div class="ecom inner-wrapper">
    <div class="maintenance">
      <h2>Scheduled Maintenance in Progress</h2>
      <div v-html="downForMaintenance" />
    </div>
  </div>
</template>

<script>
import config from '@/config'

export default {
  data () {
    return {
      downForMaintenance: config.downForMaintenance,
      brand: process.env.VUE_APP_BRAND
    }
  },
  mounted () {
    // If a user would refresh on '/maintenance' after maintenance is complete
    if (!this.$store.state.ui.isDownForMaintenance) {
      return this.$router.push({ name: 'Home' })
        .then(() => {
          window.location.reload()
        })
    }
  }
}
</script>
